exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-3af9ae02]{font-family:Arial,Helvetica,sans-serif}[data-v-3af9ae02]{box-sizing:border-box}input[type=text][data-v-3af9ae02],select[data-v-3af9ae02],textarea[data-v-3af9ae02]{width:100%;padding:12px;border:1px solid #ccc;border-radius:4px;box-sizing:border-box;margin-top:6px;margin-bottom:16px;resize:vertical}input[type=submit][data-v-3af9ae02]{background-color:#000;color:#fff;padding:12px 20px;border:none;border-radius:4px;cursor:pointer}input[type=submit][data-v-3af9ae02]:hover{background-color:grey}.container[data-v-3af9ae02]{padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3af9ae02","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/textInput.vue
// module id = 141
// module chunks = 0